import { render, staticRenderFns } from "./material-list.vue?vue&type=template&id=c87edb12&scoped=true&"
import script from "./material-list.vue?vue&type=script&lang=js&"
export * from "./material-list.vue?vue&type=script&lang=js&"
import style0 from "./material-list.vue?vue&type=style&index=0&id=c87edb12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c87edb12",
  null
  
)

export default component.exports